import type { ReactNode } from "react"
import { EmployeeOnboardingMultiStepFormHeader, type Step } from "./EmployeeOnboardingMultiStepFormHeader"
import { EmployeeOnboardingMultiStepFormFooter } from "./EmployeeOnboardingMultiStepFormFooter"

interface EmployeeOnboardingMultiStepFormLayoutProps {
  steps: Step[]
  currentStep: number
  stepStatus: boolean[]
  stepVisited?: boolean[]
  onStepChange: (stepIndex: number) => void
  onPrevious: () => void
  onNext: () => void
  onSubmit: () => void
  isSubmitting?: boolean
  isSaving: boolean
  isReadOnly?: boolean
  stepDescriptions?: Record<number, string>
  submitLabel?: string
  canSubmit?: boolean
  children: ReactNode
}

export function EmployeeOnboardingMultiStepFormContainer({
  steps,
  currentStep,
  stepStatus,
  stepVisited = [],
  onStepChange,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting = false,
  isSaving = false,
  isReadOnly = false,
  stepDescriptions = {},
  submitLabel = "Submit",
  canSubmit = true,
  children,
}: EmployeeOnboardingMultiStepFormLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <EmployeeOnboardingMultiStepFormHeader
        steps={steps}
        currentStep={currentStep}
        stepStatus={stepStatus}
        stepVisited={stepVisited}
        onStepChange={onStepChange}
        isReadOnly={isReadOnly}
        stepDescriptions={stepDescriptions}
      />

      <main className="flex-1 px-2 py-4 sm:px-4 sm:py-6">
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-card rounded-lg shadow-sm p-4 sm:p-6">
            {children}
          </div>
        </div>
      </main>

      <div className="sticky bottom-0">
        <EmployeeOnboardingMultiStepFormFooter
          currentStep={currentStep}
          totalSteps={steps.length}
          onPrevious={onPrevious}
          onNext={onNext}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          isSaving={isSaving}
          isReadOnly={isReadOnly}
          submitLabel={submitLabel}
          canSubmit={canSubmit}
        />
      </div>
    </div>
  )
}
